// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__7GPlw","content":"Modal_content__sv24t"};